import { render } from "./AdminSwaggerView.vue?vue&type=template&id=361477be&scoped=true"
import script from "./AdminSwaggerView.vue?vue&type=script&lang=js"
export * from "./AdminSwaggerView.vue?vue&type=script&lang=js"

import "./AdminSwaggerView.vue?vue&type=style&index=0&id=361477be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361477be"]])

export default __exports__